export enum enginTypes {
    LOADING = "LOADING",
    SELECTED_ENGIN = "SELECTED_ENGIN",
    GET_ENGIN_LIST = "GET_ENGIN_LIST",
    GET_VIDANGE_LIST = "GET_VIDANGE_LIST",
    GET_SYNTHESE_ENGIN = 'GET_SYNTHESE_ENGIN'
}
  
export default enginTypes;